import React, { useEffect, useState } from 'react';
import {
  Button,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Tabs,
  Tab,
  Box,
  Modal,
  Divider,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  TextField,
  FormControlLabel,
  Checkbox,
  Skeleton,
  IconButton,
} from '@mui/material';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate, useLocation, useParams } from 'react-router-dom';

import { useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import { Icon } from '@iconify/react';
import DeleteIcon from "@mui/icons-material/Delete";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { ToastContainer, toast } from 'react-toastify';
import dayjs from 'dayjs';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import { Helmet } from 'react-helmet-async';

import MyCustomUploadAdapterPlugin from './customEditor/customEditor';
import Scrollbar from '../components/scrollbar/Scrollbar';
import Iconify from '../components/iconify';
import { Api, UploadFile } from '../webservices';

const filter = createFilterOptions();

export default function Applications() {
  const { id } = useParams();
   const [loading, setLoading] = useState('');
  const navigate = useNavigate();
  const [tab, setTab] = useState('prospect');
  const [applications, setApplications] = useState([]);
  const location = useLocation();
  const { row } = location.state || {};
  const [opens, setOpens] = useState(false);
  const handleOpens = () => setOpens(true);
  const handleCloses = () => setOpens(false);
  const [emailCopy, setEmailCopy] = useState(false);
  const [phoneCopy, setPhoneCopy] = useState(false);
  const [newSkill, setNewSkill] = useState([]);
  const [openRes, setOpenRes] = useState('');
  const [openR, setOpenR] = useState(false);
 
  const openResume = (resUrl) => {
    setOpenRes(resUrl);
    setOpenR(true);
  };
  const closeResume = () => {
    setOpenR(false);
  };
  const tablebg = 'rgba(82, 130, 190, 0.08)';
  const suru = 'https://docs.google.com/viewer?url=';
  const lll = '&embedded=true';

 

  const styleClients1 = {
    height: '90%',
    position: 'absolute',
    top: '53%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: '65%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    borderRadius: 3,
  };

  const optionsDate = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  };

  // ai/screened-candidates-list
  // "prospect", "shortlisted", "rejected"



  const screenedcandidates = async (tab) => {
    setLoading('');
    setApplications([]);
    const token = localStorage.getItem('token');

    const body = {
      jobId: id,
      status: tab,
    };
    Api('ai/screened-candidates-list', 'POST', body, token)
      .then((response) => {
        if (response.data.success) {
          console.log('heelo shyamlal sharma ji ==>>>', response);
          if (response.data.candidates?.length > 0) {
            // toast.success(response.data.message)
            setApplications(response.data.candidates);
            setLoading('');
          } else {
            setLoading('No data found');
          }
        } else {
          toast.error(response.data.message);
          setLoading('No data found');
        }
      })
      .catch((err) => {
        // toast.error(err?.message || "Something went wrong!");
      });
    console.log('API Request: ', body);
  };

  const [endClientName, setEndClientName] = useState('');

  const updateStatus = async (id, status) => {
    const token = localStorage.getItem('token');

    const body = {
      "ids": id,
      "status": status,
    };

    Api('ai/update-screened-candidate-status', 'POST', body, token)
      .then((res) => {
        if (res.status === 200) {
          toast.success(res.data.message);
          // refresh list
          if (tab === 'prospect') {
            screenedcandidates('prospect');
          } else if (tab === 'shortlisted') {
            screenedcandidates('shortlisted');
          } else {
            screenedcandidates('rejected');
          }
        } else {
          toast.error(res.data.message);
        }
      })
      .catch(() => {
        toast.error('Something went wrong!');
      });
  };

  const submitApplication = async (row) => {
    navigate('/resumeDetail', {
      state: {
        endClientName,
        addedSkills: '',
        row: row?.resumeId,
        fTab: 'submitted',
        submitId: row?.resumeId?._id,
        jobId: row?.jobId,
        application: 'submit',
      },
    });
  };

  useEffect(() => {
    screenedcandidates('prospect');
    // getTemplList();
  }, []);

  const [recipientEmail, setRecipientEmail] = useState();
  const [subject, setSubject] = useState('');
  const [emailBody, setEmailBody] = useState('');
  const [ccEmail, setCcEmail] = useState([]);

  const [checkedItems, setCheckedItems] = useState({});

  const [bccEmail, setBccEmail] = useState([]);

  const allChecked = applications?.length > 0 && applications?.every((item) => checkedItems[item._id]);

  const handleCheck = (itemId, email, name) => {
    const isChecked = !checkedItems[itemId];
    const formattedName = (name || '')
      .split(' ')
      .map((word) => word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase())
      .join(' ');

    setBccEmail((prev) => {
      let updated;

      if (isChecked) {
        const alreadyExists = prev?.some((item) => item.email === email);
        if (!alreadyExists) {
          updated = [...prev, { name: formattedName, email }];
        } else {
          updated = prev;
        }
      } else {
        updated = prev.filter((item) => item.email !== email);
      }

      if (updated?.length > 0) {
        setRecipientEmail(updated[0]?.email);
      } else {
        setRecipientEmail('');
      }

      return updated;
    });

    setCheckedItems((prev) => ({
      ...prev,
      [itemId]: isChecked,
    }));
  };

  const handleSelectAll = () => {
    if (allChecked) {
      setBccEmail([]);
      setRecipientEmail('');
    } else {
      const formattedEmails =
        applications?.map((item) => ({
          name: (item?.resumeId?.fullName || '')
            .split(' ')
            .map((word) => word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase())
            .join(' '),
          email: item?.resumeId?.email || '',
        })) || [];
      setBccEmail(formattedEmails);
      if (formattedEmails?.length > 0) {
        setRecipientEmail(formattedEmails[0]?.email);
      }
    }
    const newCheckedItems = applications?.reduce((acc, item) => {
      acc[item._id] = !allChecked;
      return acc;
    }, {});
    console.log("hello shyamlal sharma ji ===>>>", newCheckedItems )
        setCheckedItems(newCheckedItems); 
  };

  const [modalOpen, setModalOpen] = useState(false);

  const handleOpenModal = (email) => {
    // setSelectedCandidateId(id);
    // setRecipientEmail(email)
    setModalOpen(true);
    // alert(`Selected Candidate ID: ${id}`);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const [greeting, setGreeting] = useState('');

  const [base64, setBase64] = useState([]);
  const [fileName, setFileName] = useState('');
  const [fileType, setFileType] = useState('');
  const [attachment, setAttachment] = useState('');

  const FileChange = (event) => {
    const file = event.target.files[0];
    // console.log("file---", event.target.files)
    if (file) {
      setFileName(file.name);
      setFileType(file.type);
      convertFileToBase64(file);
      uploadAttach(file);
    } else {
      toast.warn('No file selected!');
    }
  };

  const uploadAttach = async (file) => {
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('document', file);
    formData.append('directoryName', 'profile');
    try {
      const response = await UploadFile('resume/upload_resume', formData, token);
      if (response.status === 200 && response.data.code === 200) {
        setAttachment(response.data.filePath);
      } else {
        //   toast.warn(response.data.status + '!');
      }
    } catch (error) {
      // toast.warn('Error uploading the image!');
    }
  };

  const convertFileToBase64 = (file) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      setBase64(reader.result);
      // console.log("base64",reader.result)
    };
    reader.readAsDataURL(file);
  };

  const sign = localStorage.getItem('sign');

  const [loadingSend, setLoadingSend] = useState(false);

  const sendBulkEmail = async () => {
    setLoadingSend(true);
    const body = {
      "subject": subject,
      "attachment": attachment,
      "fileName": fileName,
      others:
        // [
        // {
        //   "name": "",
        //   "email": ""
        // }
        bccEmail,
      // ],
      mailBody: emailBody,
      //       "mailBody":`${emailBody}<br/>${sign?.replace(
      //     /<figure[^>]*>(.*?)<\/figure>/gi,
      //     (_, innerContent) => `<p>${innerContent}</p>`
      //   )
      // }`
    };
    const token = localStorage.getItem('token');
    Api(`email/send_bulk_mail`, 'POST', body, token)
      .then((response) => {
        // console.log('====rec ====', response);
        if (response.status === 200) {
          handleCloseModal();
          toast.success(response.data.message);
          setLoadingSend(false);
        }
      })
      .catch((err) => {
        toast.error(err, +'!');
      });
  };

  const [tempList, setTempList] = useState([]);

  const getTemplList = () => {
    const token = localStorage.getItem('token');
    // console.log("token ===>>>>> ",token)
    Api('email/getEmailTemplateList', 'GET', '', token)
      .then((response) => {
        // console.log('Response:---------', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            //  console.log("hhh")
          } else {
            // console.log('data:', response.data.message);
          }
        }
        setTempList(response.data.result);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };

  const handleTemplateSelect = (item) => {
    if (item && item.template && item.template.length > 0) {
      setGreeting(item.template[0].greeting);
      setSubject(item.template[0].subject);
      setEmailBody(item.template[0].emailBody);
    }
  };

  const multipleStatusChange = (type) => {
    // setLoading(true)
    // applications?.forEach(item => {
    const selectedIds = Object.keys(checkedItems).filter((id) => checkedItems[id]);

    if (selectedIds.length === 0) {
      toast.warn('Please select at least one application');
      return;
    }
    // if (checkedItems[item._id]) {

    if (type === 'reject') {
      updateStatus(selectedIds, 'rejected');
    } else {
      updateStatus(selectedIds, 'shortlisted');
    }
    // }

    // });
    setCheckedItems({});
  };

  // const [interviewList, setInterviewList] = useState([]);

const getInterviewList = async () => {
  setLoading("");
  setApplications([]);

  const token = localStorage.getItem("token");

  const body = {
    page: 1,
    limit: 30,
    status: "",
    search: "",
  };

  try {
    const res = await Api(
      "bot/scheduled_interview_list",
      "POST",
      body,
      token
    );

    if (res.data.success) {
      if (res.data.data?.length > 0) {
        setApplications(res.data.data);   // <-- yahi important hai
        setLoading("");
      } else {
        setLoading("No Interview Scheduled");
      }
    } else {
      setLoading("No Interview Scheduled");
    }
  } catch (err) {
    setLoading("No Interview Scheduled");
  }
};

  return (
    <>
      <ToastContainer />

      <Iconify
        icon="ion:arrow-back"
        fontSize={25}
        sx={{
          cursor: 'pointer',
          color: 'text.secondary',
          fontSize: '0.9rem',
          fontWeight: '600',
          mr: 1,
          mt: -1,
        }}
        onClick={() => navigate(-1)}
      />

      
      <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
        <Box sx={{}}>
          <Typography variant="h5" color="textSecondary">
            Screened Candidates
          </Typography>
        </Box>
       
       {tab !== "aiInterview" && (
        <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{ ml: 'auto', mb: 0.6 }}>
          <Button color="custom" variant="contained" size="small" onClick={() => handleSelectAll()}>
            {allChecked ? 'Deselect All' : 'Select All'}
          </Button>
          <Button
            color="custom"
            variant="contained"
            size="small"
            onClick={() => handleOpenModal(applications?.[0]?.resumeId?.email)} 
          >
            Email
          </Button>

          <Button color="custom" variant="contained" size="small" onClick={() => multipleStatusChange('shortlist')}>
            Shortlist
          </Button>
          <Button color="custom" variant="contained" size="small" onClick={() => multipleStatusChange('reject')}>
            Reject
          </Button>
        </Stack>
          )}
      </Stack>
     

      {/* <Tabs value={tab} onChange={(e, v) => setTab(v)} variant="scrollable"

       sx={{
  minHeight: 36,
  "& .MuiTabs-flexContainer": {
    alignItems: "flex-end",
  },
  "& .MuiTabs-indicator": {
    bottom: 0,
    height: 3,
    backgroundColor: "#3C6BA5",
  },
  "& .MuiTab-root": {
    minHeight: 36,
    paddingBottom: "1px",
    fontSize: "15px",     
    // fontWeight: 600,
    textTransform: "none", 
  },
  "& .MuiTab-root.Mui-selected": {
    // fontWeight: 600, 
  },
}}


      >
        <Tab label="Foxearch" />
        <Tab label="Indeed" disabled />
        <Tab label="Monster" disabled />
        <Tab label="CB" disabled />
        <Tab label="Dice" disabled />
        <Tab label="LinkedIn" disabled />
        <Tab label="Shortlisted" />
        <Tab label="Unqualified" />
      </Tabs> */}

      <Stack
        sx={{
          flexDirection: 'row',
          gap: 2,
          cursor: 'pointer',
          alignItems: 'center',
          width: '100%',
          justifyContent: 'flex-start',
          mb: 0.5,
        }}
      >
        <Stack
          sx={[
            { flexDirection: 'row', alignItems: 'center' },
            tab === 'prospect' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
          ]}
          onClick={() => {
            screenedcandidates('prospect');
            setTab('prospect');
          }}
        >
          <Iconify icon="mdi:magnify" fontSize={17} />
          <Typography variant="tabs" sx={{ ml: 1 }}>
            Prospects
          </Typography>
        </Stack>
        <Stack
          sx={[
            { flexDirection: 'row', ml: 1, alignItems: 'center' },
            tab === 'shortlisted' ? { borderBottom: 3, color: 'green' } : { color: 'text.textG' },
          ]}
          onClick={() => {
            screenedcandidates('shortlisted');
            setTab('shortlisted');
          }}
        >
          <Iconify icon="mdi:check-circle-outline" fontSize={17} />
          <Typography variant="tabs" sx={{ ml: 1 }}>
            Shortlisted
          </Typography>
        </Stack>

        <Stack
          sx={[
            { flexDirection: 'row', ml: 1, alignItems: 'center' },
            tab === 'unqualified' ? { borderBottom: 3, color: 'red' } : { color: 'text.textG' },
          ]}
          onClick={() => {
            screenedcandidates('rejected');
            setTab('unqualified');
          }}
        >
          <Iconify icon="mdi:close-circle-outline" fontSize={17} />
          <Typography variant="tabs" sx={{ ml: 1 }}>
            Unqualified
          </Typography>
        </Stack>

         <Stack
          sx={[
            { flexDirection: 'row', ml: 1, alignItems: 'center' },
            tab === 'aiInterview' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
          ]}
          onClick={() => {
            getInterviewList();
            // screenedcandidates('rejected');
            setTab('aiInterview');
          }}
        >
          <Iconify icon="ps:check-box" fontSize={17} />
          <Typography variant="tabs" sx={{ ml: 1 }}>
            AI Interview
          </Typography>
        </Stack>
      </Stack>

      <TableContainer component={Paper} sx={{ mt: 0.3 }}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow sx={{ justifyContent: 'flex-start', backgroundColor: 'text.secondary' }}>
              <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '13%' }}>Date</TableCell>
              <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '14%' }}>Detail</TableCell>
              <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '15.5%' }}>Contact Details</TableCell>
              <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '15.5%' }}>Skills</TableCell>
              <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '13%' }}>% Match</TableCell>
              <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '5%' }}> Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {applications?.map((row, index) => (
              <Condidate key={row._id} index={index} row={row} tab={tab} screenedcandidates={screenedcandidates} 
                 checkedItems={checkedItems}     
                  handleCheck={handleCheck}   
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer> 

    

      {loading === "" ? (
        <Stack>
          {Array.from({ length: 15 })?.map((_, index) => (
            <Skeleton
              key={index}
              variant="rectangular"
              sx={{
                height: 80,
                width: '100%',
                backgroundColor: index % 2 === 0 ? 'text.background' : tablebg,
              }}
            />
          ))}
        </Stack>

      ) :
        <Stack sx={{ mt: 2, p: 2 }}>
          <Typography sx={{ alignSelf: 'center', color: 'red' }}>
            {loading}

          </Typography>
        </Stack>
      }

    

      {/* <Modal open={openR} onClose={closeResume} style={{ borderRadius: 10 }}>
        <Box sx={styleClients1}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
              mt: -2.5,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                textAlign: 'center',
                color: 'text.secondary',
                fontWeight: 'bold',
                flex: 1,
                mb: 1,
                mt: 1,
              }}
            >
              Resume
            </Typography>
            <a href={openRes} download>
              <Iconify icon="mdi:download" width="1.3rem" color="text.secondary" />
            </a>
          </Box>
          <Scrollbar
            sx={{
              height: '97%',
              Scrollbar: 'thin',
              border: '2px solid #3C6BA5',
              borderColor: 'text.secondary',
              borderRadius: 2,
            }}
          >
            <Stack sx={{ p: 1.5 }}>
              <Box sx={{ overflowX: 'auto', minWidth: '600px' }}>
                <iframe title="resume" src={suru + openRes + lll} width="100%" height="700px" />
              </Box>
            </Stack>
          </Scrollbar>
        </Box>
      </Modal> */}

      {/* <Modal open={modalOpen} onClose={handleCloseModal} style={{ borderRadius: 10 }}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '95%', sm: '70%' },
          
            bgcolor: 'background.paper',
            border: '3px solid #3C6BA5',
            boxShadow: 24,
            p: 3,
            borderRadius: 3,
          }}
        >
          <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
            Send Email
          </Typography>
          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
         
            <Grid container spacing={1} mt={1}>
              <Grid item xs={5.9}>
                <TextField
                  fullWidth
                  required
                  label="To"
                  variant="outlined"
                  size="small"
                  // value={to}
                  value={recipientEmail}
                  // onChange={(e) => setTo(e.target.value)}
                  onChange={(e) => setRecipientEmail(e.target.value)}
                />
              </Grid>
              <Grid item xs={5.9}>
                <Autocomplete
                  size="small"
                  multiple
                  id="tags-outlined"
                  onChange={(event, newValue) => {
                    setCcEmail([...newValue]);
                  }}
                  options={[{ title: '' }]}
                  getOptionLabel={(option) => option.title}
                  value={ccEmail.map((item) => item)}
                  filterSelectedOptions
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);
                    const { inputValue } = params;
                    // Suggest the creation of a new value
                    const isExisting = options.some((option) => inputValue === option.title);
                    if (inputValue !== '' && !isExisting) {
                      filtered.push({
                        inputValue,
                        title: `${inputValue}`,
                      });
                    }
                    return filtered;
                  }}
                  renderInput={(params) => <TextField {...params} label="Cc" placeholder="Cc" size="small" />}
                />
              </Grid>
            </Grid>
            <Grid container spacing={1} mt={1}>
              <Grid item xs={5.9}>
                <Autocomplete
                  multiple
                  size="small"
                  id="tags-outlined"
                  value={bccEmail}
                  onChange={(event, newValue) => {
                    setBccEmail(newValue);
                  }}
                  options={[]}
                  getOptionLabel={(option) => option.email || option.title || ''}
                  isOptionEqualToValue={(option, value) => option.email === value.email}
                  filterSelectedOptions
                  filterOptions={(options, params) => {
                    const { inputValue } = params;

                    const isExisting = bccEmail.some((item) => item.email === inputValue);
                    if (inputValue !== '' && !isExisting) {
                      return [
                        ...options,
                        {
                          name: '',
                          email: inputValue,
                        },
                      ];
                    }

                    return options;
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Others"
                      placeholder="Others"
                      multiline
                      rows={3}
                      size="small"
                      InputProps={{
                        ...params.InputProps,
                        sx: {
                          alignItems: 'flex-start',
                          '& textarea': {
                            textAlign: 'left',
                            paddingTop: '1px !important',
                          },
                        },
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={5} sx={{}}>
                <FormControl variant="outlined" fullWidth size="small">
                  <InputLabel>Select Template</InputLabel>
                  <Select label="Select Template" onChange={(e) => handleTemplateSelect(e.target.value)}>
                    {tempList?.map((item) => (
                      <MenuItem key={item?.id} value={item}>
                        {item?.templateName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Typography
                onClick={() => navigate('/Email', { state: { undid: 'undid', bodyDis: 'bodyDis' } })}
                sx={{
                  color: '#23A6F0',
                  fontWeight: 'bold',
                  fontSize: '17px',
                  marginLeft: '30px',
                  marginTop: '12px',
                  cursor: 'pointer',
                }}
              >
                Edit
              </Typography>
            </Grid>

            <Grid container alignItems="center" style={{ flexDirection: 'row' }}>
              <Grid item xs={12} style={{ display: 'flex', alignItems: 'center' }}>
                <Typography sx={{ ml: 1, color: '#1E74B3', whiteSpace: 'nowrap' }}>Attachment:</Typography>
                <input
                  type="file"
                  onChange={FileChange}
                  style={{
                    marginLeft: '9px',
                    flex: 1,
                    minWidth: 0,
                  }}
                />
              </Grid>
            </Grid>

            <Grid container spacing={1}>
              <Grid item xs={11.8}>
                <TextField
                  label="Sub"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  size="small"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  InputProps={{ style: { borderRadius: '10px', paddingLeft: '5px' } }}
                  // InputLabelProps={{ style: { marginLeft: '14px' } }}
                />
              </Grid>
              <Grid item xs={11.8}>
                <Stack sx={{ flexDirection: 'row', gap: 1, alignItems: 'center' }}>
                  <Typography>Hello {'{Name},'}</Typography>
                </Stack>
              </Grid>
              <Grid item xs={11.8}>
                <CKEditor
                  data={emailBody}
                  config={{
                    extraPlugins: [MyCustomUploadAdapterPlugin],
                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    // console.log("body", data)
                    setEmailBody(data);
                  }}
                  editor={ClassicEditor}
                />
              </Grid>
            </Grid>
            <Stack sx={{ mt: 1 }}>
              <div dangerouslySetInnerHTML={{ __html: localStorage.getItem('sign') }} />
            </Stack>

            <Stack flexDirection={'row'} gap={1} mt={1} sx={{ justifyContent: 'center' }}>
              <Button
                color="custom"
                variant="contained"
                // onClick={SendEmail}
                disabled={recipientEmail === '' || subject === '' || loadingSend}
                onClick={() => sendBulkEmail()}
              >
              
                {loadingSend ? 'Sending' : 'Send'}
              </Button>
            </Stack>
          </Scrollbar>
        </Box>
      </Modal> */}
    </>
  );
}

function Condidate({ row, index, tab, screenedcandidates, checkedItems,
  handleCheck   }) {

  const [opens, setOpens] = useState(false);
  const handleOpens = () => setOpens(true);
  const handleCloses = () => setOpens(false);
  const [newSkill, setNewSkill] = useState([]);
  const [emailCopy, setEmailCopy] = useState(false);
  const [phoneCopy, setPhoneCopy] = useState(false);
  const [openRes, setOpenRes] = useState('');
  const [openR, setOpenR] = useState(false);
  const openResume = (resUrl) => {
    setOpenRes(resUrl);
    setOpenR(true);
  };
    const closeResume = () => {
    setOpenR(false);
  };
  
  const styleClients1 = {
    height: '90%',
    position: 'absolute',
    top: '53%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: '65%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    borderRadius: 3,
  };

  const scheduleStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90%", sm: "450px" },
  bgcolor: "background.paper",
  border: "3px solid #3C6BA5",
  boxShadow: 24,
  borderRadius: 3,
  p: 3,
};

  const updateStatus = async (id, status) => {
    const token = localStorage.getItem('token');

    const body = {
      "ids": id,
      "status": status,
    };



    Api('ai/update-screened-candidate-status', 'POST', body, token)
      .then((res) => {
        if (res.data.success) {
          toast.success(res.data.message);
          // refresh list
          if (tab === 'prospect') {
            screenedcandidates('prospect');
          } else if (tab === 'shortlisted') {
            screenedcandidates('shortlisted');
          } else {
            screenedcandidates('rejected');
          }
        } else {
          toast.error(res.data.message);
        }
      })
      .catch(() => {
        toast.error('Something went wrong!');
      });
  };
  const tablebg = 'rgba(82, 130, 190, 0.08)';
    const suru = 'https://docs.google.com/viewer?url=';
  const lll = '&embedded=true';

  const optionsDate = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  };
   const styleSkillset11 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '50%', sm: '70%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    // paddingTop:3,
    // paddingBottom:3,
    borderRadius: 3,
  };



   const [open1, setOpen1] = useState(false);
  const [scoreDetails, setScoreDetails] = useState(null);
  const [scoreReasons, setScoreReasons] = useState(null);
  const[score,setscore]=useState(null);
  const [interviewToken, setInterviewToken] = useState("");
   const handleScoreClick=(item)=>{
         setScoreDetails(item?.
breakdown
);
         setScoreReasons(item?.reasons);
         setscore(item?.score)
         setOpen1(true)
   }

   const [schedule, setSchedule] = useState({
                                            date: "",
                                            time: "",
                                          });
    const [openSchedule, setOpenSchedule] = useState(false);
    const formatDate = (date) => {
               if (!date) return "";

         const [year, month, day] = date.split("-");
         return `${day}-${month}-${year}`;
      };

      const getInterviewDateTimeUTC = (date, time) => {
  if (!date || !time) return "";

  const localDate = new Date(`${date}T${time}:00`);

  return localDate.toISOString();
};


     const validateInterview = () => {
       if (!schedule.date) {
          toast.warn("Please select interview date");
          return false;
       }

       if (!schedule.time) {
          toast.warn("Please select interview time");
          return false;
        }

       if (!timez.short) {
          toast.warn("Please select timezone");
          return false;
       }

       return true;
      };


    //  const handleSubmitInterview = () => {
    //    if (!validateInterview()) return;
    //   const url = `${window.location.origin}/interview?jobTitle=${encodeURIComponent(
    //                   row.candidateId.jobTitle
    //                   )}&clientName=${encodeURIComponent(
    //                   localStorage.getItem("companyName")
    //                   )}&fullName=${encodeURIComponent(
    //                    row.candidateId.fullName 
    //                   )}&date=${encodeURIComponent(
    //                   formatDate(schedule.date)
    //                   )}&time=${encodeURIComponent(
    //                   formatTimeToAMPM(schedule.time)
    //                   )}&timezone=${encodeURIComponent(
    //                     timez.short
    //                   )}&token=${encodeURIComponent(
    //                     localStorage.getItem('token')
    //                   )}&inetviewId=${encodeURIComponent(
    //                     row.interviewId
    //                   )}&adminName=${encodeURIComponent(
    //                    localStorage.getItem("contactPersonName")
    //                   )}`;
          
    //   const token = localStorage.getItem('token');
    // console.log("interview Token:",interviewToken)
    //     const body = 
    //     {
    //       "screeningResultId": row._id,
    //       "interviewDate": getInterviewDateTimeUTC(
    //                                   schedule.date,
    //                                    schedule.time
    //                                 ),
    //       "interviewTime": formatTimeToAMPM(schedule.time),
    //       "timeZone": timez.short,
    //       "link": url
    //     }
    
    //     Api('bot/schedule_interview', 'POST', body, token)
    //       .then((res) => {
    //         console.log(res);
    //         if (res.status) {
    //           if (res.data.success) {
    //             toast.success(res.data.message)
    //             setInterviewToken(res.data.data.interviewToken)
    //              setSchedule({
    //                        date: "",
    //                        time: "",
    //                      });
    //                   setTimez   ({ short: "", full: "" })
    //             setOpenSchedule(false);
    //             // setTableData(res.data.data);
    //           } else {
    //             toast.error(res.data.message);
    //           }
    //         }
    //       })
    //       .catch((err) => {
    //         console.log(err);
    //       });
    //   };

   const handleSubmitInterview = (isRequestSchedule = false) => {
      if (!isRequestSchedule && !validateInterview()) {
    return;
  }

     let url = `${window.location.origin}/interview?jobTitle=${encodeURIComponent(
           row.candidateId.jobTitle
         )}&clientName=${encodeURIComponent(
          localStorage.getItem("companyName")
          )}&fullName=${encodeURIComponent(
           row.candidateId.fullName
        )}&date=${encodeURIComponent(
           formatDate(schedule.date)
        )}&time=${encodeURIComponent(
           formatTimeToAMPM(schedule.time)
        )}&timezone=${encodeURIComponent(
          timez.short
        )}&token=${encodeURIComponent(
           localStorage.getItem("token")
         )}&interviewId=${encodeURIComponent(
             interviewIds
        )}&adminName=${encodeURIComponent(
          localStorage.getItem("contactPersonName")
           )}`;

        // Sirf Request to Schedule ke liye
        if (isRequestSchedule) {
             url += `&requestSchedule=true`;
          }

        const token = localStorage.getItem("token");

         const body = {
             screeningResultId: row._id,
             interviewDate: getInterviewDateTimeUTC(
                  schedule.date,
                  schedule.time
                  ),
             interviewTime: formatTimeToAMPM(schedule.time),
             timeZone: timez.short,
             link: url,
            };

       Api("bot/schedule_interview", "POST", body, token)
           .then((res) => {
            if (res.status) {
              if (res.data.success) {
                toast.success(res.data.message);
                 setInterviewToken(res.data.data.interviewToken);
                setSchedule({
                      date: "",
                      time: "",
                     });
                setTimez({ short: "", full: "" });
                setOpenSchedule(false);
               } else {
                toast.error(res.data.message);
              }
            }
          })
         .catch((err) => {
           console.log(err);
           });
          };

    const handleOpenSchedule = () => {
      console.log(row)
       setOpenSchedule(true);
       };

    const handleCloseSchedule = () => {
           setOpenSchedule(false);

             setSchedule({
                           date: "",
                           time: "",
                         });
                      setTimez   ({ short: "", full: "" })
                };

//     const handleSubmitInterview = () => {
//           console.log(schedule);
//           console.log(timez);
          


//         const url = `${window.location.origin}/interview?jobTitle=${encodeURIComponent(
//   row.candidateId.jobTitle
// )}&clientName=${encodeURIComponent(
//   row.candidateId.clientName
// )}&date=${encodeURIComponent(
//   schedule.date
// )}&time=${encodeURIComponent(
//   schedule.time
// )}&timezone=${encodeURIComponent(timez.short)}`;

// console.log('Interview url===>>>>>',url);
//   // API Call
//   // schedule.date
//   // schedule.time

//             handleCloseSchedule();
//       };

const formatTimeToAMPM = (time) => {
  if (!time) return "";

  const [hours, minutes] = time.split(":");

  return new Date(0, 0, 0, hours, minutes).toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

const [timez, setTimez] = useState({ short: "", full: "" });
     const timeZones = [
    { short: "EST", full: "America/New_York" },
    { short: "PST", full: "America/Los_Angeles" },
    { short: "MST", full: "America/Denver" },
    { short: "CST", full: "America/Chicago" },
    { short: "IST", full: "Asia/Kolkata" },
  ];

  const handleChangeTimeZ = (e) => {
    const selectedShort = e.target.value;
    const selectedZone = timeZones.find((tz) => tz.short === selectedShort);
    setTimez(selectedZone);
  };
  // console.log("AI Interview Row =", row);

  const [openI, setOpenI] = useState(false);
    const openInterview = (interviewId) => {
      
      // listAllQuestions(interviewId);
      setOpenI(true);
      // handleGenerateQuestions(interviewId);
    };
    const closeInterview = () => {
      setOpenI(false);
    };

     const [tabValue, setTabValue] = useState(0);
    // const [openQuestionModal, setOpenQuestionModal] = useState(false);
    // const [technicalQuestion, setTechnicalQuestion] = useState("");
    const [allQuestions, setAllQuestions] = useState([]);
    const [questionList, setQuestionList] = useState([]);
     const [interviewIds ,setInterviewIds] = useState('');
     const [openResult, setOpenResult] = useState(false);
     const [ completeReport, setCompleteReport] = useState('');
     const [videoOpen, setVideoOpen] = useState(false);
     const [selectedVideo, setSelectedVideo] = useState("");
     console.log("send interview id through params",interviewIds);
    
     const closeResult = () => {
  setOpenResult(false);
};

    const handleTabChange = (event, newValue) => {
      setTabValue(newValue);
      // if(newValue === 1){
      //   getlist();
      // }
    };
    
   
    
        const listAllQuestions = (interviewId) => {
        console.log("id+++==>>",interviewIds)
         const body = {
        "interviewId": interviewId,
        // "question": technicalQuestion
         }
         console.log("body++==>>",body)
        const token = localStorage.getItem("token")
         Api('bot/getAllInterviewQuestions', 'POST', body, token)
           .then((res) => {
             console.log(res);
             if (res.status === 200) {
               if (res.data.success) {
                //  toast.success(res.data.message)
                 setAllQuestions(res.data.data);
               } else {
                 toast.success(res.data.message);
               }
             }
           })
           .catch((err) => {
             console.log(err);
           });
       };

      const fixedQuestions = allQuestions.filter(
        (item) => item.questionType === "HR"
        );

      const technicalQuestions = allQuestions.filter(
        (item) => item.questionType === "Technical-Manual"
        );

      const aiQuestions = allQuestions.filter(
        (item) => item.questionType === "Technical-AI"
        );

       const currentQuestions =
         tabValue === 0
         ? fixedQuestions
         : tabValue === 1
         ? technicalQuestions
         : aiQuestions;

      const handleDeleteQuestion = (id) => {
           setAllQuestions((prev) => prev.filter((item) => item._id !== id));
         };


         const handleSaveInterviewQuestions = async () => {
              try {
               const payload = {
                         interviewId: interviewIds, 
                        questions: allQuestions.map((item) => ({
                          question: item.question,
                          questionType: item.questionType,
                          difficulty: item.difficulty || "",
                       })),
                      };
           const token = localStorage.getItem("token")
           const res = await Api(
                 "bot/save_interview_questions",
                 "POST",
                 payload,
                 token
             );

        // console.log("save interview questions::", res);

             if (res?.data?.success) {
                   toast.success(res.data.message);
                   listAllQuestions();
                   closeInterview();
                   handleOpenSchedule();
             } else {
              toast.error(res?.data?.message || "Failed to save questions");
              }
          } catch (error) {
               console.error(error);
               toast.error("Something went wrong");
                }
               };

        const handleGenerateQuestions = async (interviewId) => {
             try {
              const payload = {
                         interviewId,
                        };
              const token = localStorage.getItem("token")

              const res = await Api(
                        "bot/generate_questions",
                        "POST",
                        payload,
                        token
                       );

             console.log("Generate Questions:", res);

             if (res?.data?.success) {
              listAllQuestions(interviewId)
                  // toast.success(res.data.message);
                  //  openInterview()
      // API agar questions return karti hai to state update kar do
      // if (res.data.data?.questions) {
      //   setAllQuestions(res.data.data.questions);
      // }
           } else {
                toast.error(res?.data?.message || "Failed to generate questions");
               }
          } catch (error) {
              console.error(error);
              toast.error("Something went wrong");
              }
            };

       const getlist = () =>{
        
        listAllQuestions();
    
       }
    
       const listFixedQuestions = () => {
            
           
           const token = localStorage.getItem("token")
            Api('bot/list_hr_questions', 'GET', '', token)
              .then((res) => {
                console.log(res);
                if (res.status === 200) {
                  if (res.data.success) {
                   //  toast.success(res.data.message)
                    setQuestionList(res.data.data);
                  } else {
                    toast.success(res.data.message);
                  }
                }
              })
              .catch((err) => {
                console.log(err);
              });
          };

           const styleClients11 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '60%', sm: '80%' },
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    borderRadius: 3,
  };

const handleCreateInterview = async () => {
  try {
    const body = {
      screeningResultId: row._id, // ya jo ID pass karni ho
    };
    const token = localStorage.getItem("token")
    const res = await Api(
      "bot/create_interview",
      "POST",
      body,
      token // ya localStorage.getItem("token")
    );

    console.log("Create Interview Response:", res);
    console.log("Create InterviewId Response:", res.data.data.interviewId);
    if (res?.data?.success) {
      // toast.success(res.data.message);
      // Agar kuch state update karni ho to yahan karo
     const interviewId = res.data.data.interviewId;

       setInterviewIds(interviewId);
        handleGenerateQuestions(interviewId);
        openInterview(interviewId);
    } else {
      toast.error(res?.data?.message || "Something went wrong");
    }
  } catch (err) {
    console.error(err);
    toast.error("Something went wrong");
  }
};

  const completedInterviewReport = async () => {
              try {
               const payload = {
                         interviewId: row._id, 
                       
                      };
           const token = localStorage.getItem("token")
           const res = await Api(
                 "bot/getInterviewReport",
                 "POST",
                 payload,
                 token
             );

        // console.log("save interview questions::", res);

             if (res?.data?.success) {
                   toast.success(res.data.message);
                   setCompleteReport(res.data.data);
                   setOpenResult(true);
             } else {
              toast.error(res?.data?.message || "Failed to fetch report");
              }
          } catch (error) {
               console.error(error);
               toast.error("Something went wrong");
                }
               };


  return (
    <>
    <TableRow
      key={row._id}
      sx={[
        { background: index % 2 === 0 ? 'text.background' : tablebg },
        { '&:last-child td, &:last-child th': { border: 0 } },
        { '&:hover': { boxShadow: 5 } },
      ]}
    >
      <TableCell sx={{ verticalAlign: 'top' }}>
        {/* <Stack sx={{ flexDirection: "row" }}> */}

        <Stack sx={{ flexDirection: 'column' }}>

    
       { tab !== 'aiInterview' ? (
           <>
          <Typography sx={{}}>
            Up -{' '}
            {row.updatedAt ? (
              <>
                {new Date(row.updatedAt)?.toLocaleString('en-US', {
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric',
                })}{' '}
                {(() => {
                  const date = new Date(row.updatedAt);
                  const hours = date.getHours().toString().padStart(2, '0');
                  const minutes = date.getMinutes().toString().padStart(2, '0');
                  return `${hours}:${minutes}`;
                })()}
              </>
            ) : (
              ' -'
            )}
          </Typography>
          {/* <Typography>-</Typography> */}
          <Typography sx={{}}>
            Cr -{' '}
            {`${new Date(row.createdAt)?.toLocaleString('en-US', optionsDate)} 
                                     ${String(new Date(row?.createdAt)?.getHours())?.padStart(2, '0')}:${String(
              new Date(row?.createdAt)?.getMinutes()
            )?.padStart(2, '0')}`}
          </Typography>
          </> 
          ) : (
             <>
    {/* AI Interview ke liye jo dikhana ho */}
           <Typography>
               Int. -{" "}
               {`${new Date(row.interviewDate).toLocaleString("en-US", optionsDate)}
                 `}
            </Typography>

            <Typography>
              Time - {row.interviewTime}{" "}{row.timeZone}
            </Typography>
          </>
          )}


          <Stack
            sx={{
              flexDirection: 'column',
              // mt:-1,
              // mr:-1,
              // mb:-1.5,
              p: 0,
              ml: -1,
              mb: -0.1,
              mt: -0.1,
              cursor: 'pointer',
            }}
          >
            <FormControlLabel
              sx={{
                m: 0,
                p: 0,
              }}
              control={
                <Checkbox
                  sx={{
                    p: 0.5,
                  }}
                  checked={!!checkedItems[row._id]}
                  onChange={() => handleCheck(row?._id, row?.candidateId?.email, row?.candidateId?.fullName)}
                />
              }
              label=""
            />
          </Stack>
        </Stack>
        {/* </Stack> */}
      </TableCell>

      <TableCell sx={{ maxWidth: 170, overflow: 'hidden', textOverflow: 'ellipsis', verticalAlign: 'top' }}>
        <Stack sx={{ flexDirection: 'row', alignItems: 'center' }}>
          <Typography
            sx={{ fontWeight: '600', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }}
            color={'text.secondary'}
          >
            {row?.candidateId?.fullName || row?.candidateId?.fullName || row?.fullName || '-'}
          </Typography>
          <Iconify
            icon="devicon:linkedin"
            color={'text.textG'}
            // color={row.linkedinUrl ? 'text.textG' : 'text.disabled'}
            sx={{
              ml: 1,
              height: 18,
              width: 18,
              cursor: 'pointer',
              // opacity: row.linkedinUrl ? 1 : 0.5,
            }}
            hover
            onClick={() =>
              window.open(row?.candidateId?.linkedinUrl || row?.candidateId?.linkedinUrl || row?.linkedinUrl, '_blank')
            }
            // onClick={() => {
            //   if (row.linkedinUrl) {
            //     window.open(row.linkedinUrl, '_blank');
            //   }
            // }}
          />

          <Iconify
            icon="cuida:document-text-outline"
            color="#1E74B3"
            sx={{
              ml: 0.6,
              height: 18,
              width: 18,
              cursor: 'pointer',
            }}
            hover
            onClick={() => openResume(row.candidateId?.
resumeUrl)}
          />
        </Stack>

        <Typography sx={{ maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {row?.candidateId?.currentCompany ||
            row?.candidateId?.currentCompany ||
            row?.candidateId?.currentCompany ||
            '-'}
        </Typography>
        <Typography sx={{ maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {row?.candidateId?.jobTitle || row?.candidateId?.jobTitle || row?.candidateId?.jobTitle || '-'}
        </Typography>
      </TableCell>

      <TableCell sx={{ verticalAlign: 'top' }}>
        {row?.candidateId?.phone ? (
          <Stack sx={{ flexDirection: 'row' }}>
            <Typography sx={{ flexDirection: 'row', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {row?.candidateId.phone?.trim()
                ? row?.candidateId.phone
                    ?.trim()
                    ?.replace(/\s+/g, '')
                    ?.replace(/^(\+?\d{1,3})?(\d{10,20})$/, (match, p1, p2) => {
                      if (p1) {
                        const countryCode = p1;
                        const lastDigits = p2?.slice(-10);
                        return `${countryCode} ${lastDigits?.replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3')}`;
                      }
                      return p2?.replace(/(\d{3})(\d{3})(\d{4})(\d{3,4})?/, '$1 $2 $3 $4')?.trim();
                    })
                : ''}
            </Typography>
            {row?.candidateId?.phone && (
              <CopyToClipboard
                text={
                  row?.candidateId?.phone?.trim()
                    ? row?.candidateId?.phone
                        ?.trim()
                        ?.replace(/\s+/g, '')
                        ?.replace(/^(\+?\d{1,3})?(\d{10,20})$/, (match, p1, p2) => {
                          if (p1) {
                            const countryCode = p1;
                            const lastDigits = p2?.slice(-10);
                            return `${countryCode} ${lastDigits?.replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3')}`;
                          }
                          return p2?.replace(/(\d{3})(\d{3})(\d{4})(\d{3,4})?/, '$1 $2 $3 $4')?.trim();
                        })
                    : ''
                }
                onCopy={() => setPhoneCopy(true)}
              >
                <Iconify
                  icon="radix-icons:copy"
                  color={phoneCopy ? 'text.secondary' : 'text.textG'}
                  sx={{ ml: 1, height: 17, width: 17, cursor: 'pointer' }}
                  hover
                />
              </CopyToClipboard>
            )}
          </Stack>
        ) : (
          <Typography>-</Typography>
        )}

        {row.candidateId.email ? (
          <Stack sx={{ flexDirection: 'row' }}>
            <Typography
              sx={{ textTransform: 'lowercase', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }}
            >
              {row.candidateId.email}
            </Typography>
            {row.candidateId.email && (
              <CopyToClipboard text={row.candidateId.email} onCopy={() => setEmailCopy(true)}>
                <Iconify
                  icon="radix-icons:copy"
                  color={emailCopy ? 'text.secondary' : 'text.textG'}
                  sx={{ ml: 1, height: 17, width: 17, cursor: 'pointer' }}
                />
              </CopyToClipboard>
            )}
          </Stack>
        ) : (
          <Typography>-</Typography>
        )}

        <Stack sx={{ flexDirection: 'row', gap: 0.5, maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }}>
          <Typography>
            {row?.candidateId?.city || row?.candidateId?.stateCode
              ? `${row?.candidateId?.city}, ${row?.candidateId?.stateCode}`
              : row?.candidateId?.city || row?.candidateId?.stateCode
              ? `${row?.candidateId?.city}, ${row?.candidateId?.stateCode || '-'}`
              : row?.candidateId?.city || row?.candidateId?.stateCode
              ? `${row?.candidateId?.city}, ${row?.candidateId?.stateCode || '-'}`
              : '-'}
          </Typography>
          {row?.candidateId.relocation === 'yes' ? (
            <Iconify icon="mdi:aeroplane" fontSize={19} color={'text.secondary'} />
          ) : (
            ''
          )}
        </Stack>
      </TableCell>

      <TableCell sx={{ width: 180, verticalAlign: 'top' }}>
        {row?.candidateId?.skill ||
        row?.candidateId?.skill ||
        (row?.candidateId?.skill &&
          (row?.candidateId?.skill.length > 0 ||
            row?.candidateId?.skill.length > 0 ||
            row?.resumeId?.skill.length > 0)) ? (
          <Grid container sx={{ maxWidth: 170, height: 44, overflow: 'hidden', textOverflow: 'ellipsis', gap: 0.3 }}>
            {(row?.candidateId?.skill || row?.candidateId?.skill || row?.candidateId?.skill)?.slice(0, 4).map(
              (item, index, arr) =>
                item && (
                  <Typography key={index} sx={{ display: 'inline' }}>
                    {item}
                    {index < arr.length - 1 && ' | '}
                  </Typography>
                )
            )}
          </Grid>
        ) : (
          <Typography>-</Typography>
        )}

        {/* {(row?.benchAppId?.skill || row?.recruitorAppId?.skill || row?.skill)?.length > 0 ? ( */}
        <Typography
          sx={{ color: 'text.secondary', textDecoration: 'underline', cursor: 'pointer' }}
          onClick={() => {
            handleOpens();

            setNewSkill(row?.candidateId?.skill || row?.candidateId?.skill || row?.skill);
          }}
        >
          view all
        </Typography>
      </TableCell>

      <TableCell sx={{ width: 110, overflow: 'hidden', textOverflow: 'ellipsis', verticalAlign: 'top' }}>
        <Box   sx={{ color: '#286ACC', cursor: 'pointer', fontWeight: '600' }}
         onClick={()=>handleScoreClick(row)}
        >
                {row?.score ? `${row.score}% Match` : '-'}
        </Box>
        
         { tab !== 'aiInterview' ? (
           <>   
                <Typography
          sx={{ color: 'text.secondary', textDecoration: 'underline', cursor: 'pointer' }}
          
           onClick={() => {
            handleCreateInterview()
            // openInterview()
            // handleGenerateQuestions()
          }}
          
        >
          AI Interview
        </Typography>
        </>
         ) : (
          <>
              <Typography
          sx={{ color: 'text.secondary', }}
          
          //  onClick={() => {
          //   // openInterview()
          //   // handleGenerateQuestions()
          // }}
          
        >
          {row?.status}
        </Typography>

          


          </>
         )}

        { row?.status === 'completed' && (
          <>
          <Typography
          sx={{ color: 'text.secondary', textDecoration: 'underline', cursor: 'pointer' }}
          
           onClick={() => {
              completedInterviewReport()
            // alert('report of interview')
            // handleCreateInterview()
            // openInterview()
            // handleGenerateQuestions()
          }}
          
        >
          Report
        </Typography>
        </>
         )}
        {/* <>
          <Box sx={{ display: 'flex', alignItems: 'center', color: 'text.secondary' }}>
            <Typography sx={{ paddingRight: 1 }}>{row?.candidateId?.visaType || '-'}</Typography>
            {row?.candidateId?.visaTransfer === 'yes' ? (
              <Iconify icon="fluent:arrow-swap-16-filled" width="1.1rem" />
            ) : null}
          </Box>

          <Typography sx={{}}>
            {row?.candidateId?.expectedCompensation ? (
              <>
                ${row?.candidateId?.expectedCompensation}
                {row?.candidateId?.chargeType === 'hourly' ? '/Hour' : 'K'}
              </>
            ) : (
              '-'
            )}
          </Typography>

          <Typography sx={{ textTransform: 'capitalize' }}>{row?.candidateId?.taxTerm || '-'}</Typography>
        </> */}
      </TableCell>

      <TableCell sx={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
        <Stack sx={{ flexDirection: 'row', color: 'text.secondary', cursor: 'pointer' }}>
          {/* <Iconify icon="ic:baseline-email" fontSize={10} /> */}

          <Iconify icon="icon-park-solid:check-one" fontSize={8} />
          <Typography
            sx={{}}

            //  onClick={() => submitApplication(row)}
          >
            Submit
          </Typography>
        </Stack>

        <Stack sx={{ flexDirection: 'row', color: 'text.secondary', cursor: 'pointer' }}>
          <Iconify icon="mdi:check-circle-outline" fontSize={8} />
          <Typography sx={{}} onClick={() => updateStatus([row._id], 'shortlisted')}>
            Shortlist
          </Typography>
        </Stack>

        <Stack sx={{ flexDirection: 'row', color: 'text.secondary', cursor: 'pointer' }}>
          <Iconify icon="mdi:close-circle-outline" fontSize={8} />
          <Typography sx={{}} onClick={() => updateStatus([row._id], 'rejected')}>
            Reject
          </Typography>
        </Stack>
      </TableCell>
    </TableRow>

     <Modal open={openI} onClose={closeInterview}>
              <Box sx={styleClients11}>
                 <Typography
                     variant="h6"
                     sx={{ textAlign: "center", color: "text.secondary" }}
                   >
                   Interview Questions
                 </Typography>
    
                  <Divider  />
    
                  {/* Tabs */}
                  <Tabs
                     value={tabValue}
                     onChange={handleTabChange}
                    // sx={{ mt: 1 }}
                     centered
                    >
                  <Tab label="Fixed Questions" />
                  <Tab label="Technical Questions" />
                  <Tab
                       label="Ai Questions"
                      //  onClick={() => handleGenerateQuestions()}
                    />
                </Tabs>
    
                    {/* All Questions */}
                    
                    <Stack
                     sx={{
                        border: 1,
                        borderColor: "text.secondary",
                        borderRadius: 2,
                        p: 2,
                        mt: 2,
                        height: 350,          // ya maxHeight: 350
                        overflowY: "auto", 
                      }}
                    >
                 {currentQuestions.length > 0 ? (
                  currentQuestions.map((item, index) => (
                 <Box
                    key={item._id}
                    sx={{
                     p: 1.5,
                     mb: 1,
                     border: "1px solid #E0E0E0",
                     borderRadius: 1,
                     bgcolor: "#F9F9F9",
                     display: "flex",
                     justifyContent: "space-between",
                     alignItems: "center",
                     gap: 2,
                    }}
                 >
                <Typography variant="body2">
                    <strong>Q{index + 1}.</strong> {item.question}
                </Typography>

              <IconButton
                  color="error"
                  onClick={() => {
                    handleDeleteQuestion(item._id)
                  // alert('delete')
                  }}
                  >
                <DeleteIcon />
             </IconButton>

             </Box>
            ))
             ) : (
            <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ textAlign: "center", mt: 8 }}
               >
                Loading questions.....
             </Typography>
              )}
                    </Stack>
                  
    
              
    <Box
  sx={{
    display: "flex",
    justifyContent: "center",
    mt: 2,
  }}
>

    <Button
            variant="contained"
  sx={{
    mt: 2,
    bgcolor: "text.secondary",
    color: "#fff",
    px: 4,
    "&:hover": {
      bgcolor: "text.secondary",
      opacity: 0.9,
    },
  }}
  onClick={()=>{
    handleSaveInterviewQuestions()
    // handleOpenSchedule()
    // alert('hello questions')
  }}
>
  Continue to Schedule
</Button>
</Box>
               </Box>
             </Modal>

             <Modal open={openResult} onClose={closeResult}>
  <Box sx={styleClients11}>
    <Typography
      variant="h6"
      sx={{
        textAlign: "center",
        color: "text.secondary",
        fontWeight: 600,
        mb: 1,
      }}
    >
      Interview Result
    </Typography>

    <Divider />

    <Stack spacing={1} sx={{ mt: 2 }}>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 2,
        }}
      >
      {/* Candidate Name */}
      <Box
        sx={{
          border: "1px solid #E0E0E0",
          borderRadius: 2,
          p: 2,
          bgcolor: "#F9F9F9",
          textAlign: "center",
        }}
      >
        <Typography variant="body2" color="text.secondary">
          Candidate Name
        </Typography>

        <Typography variant="h6" fontWeight={600}>
          {completeReport?.interviewDetails?.candidateName || "N/A"}
        </Typography>
      </Box>

    {/* REview interview */}
      <Box
        sx={{
          border: "1px solid #E0E0E0",
          borderRadius: 2,
          p: 2,
          bgcolor: "#F9F9F9",
          textAlign: "center",
        }}
      >
        <Typography variant="body2" color="text.secondary">
          Review Interview
        </Typography>

        <Button
        variant="contained"
        onClick={() => {
    setSelectedVideo(row?.recordingUrl);
    setVideoOpen(true);
  }}
        sx={{
          mt: 1,
          bgcolor: "text.secondary",
          color: "#fff",
          px: 4,
          "&:hover": {
            bgcolor: "text.secondary",
            opacity: 0.9,
          },
        }}
      >
        View
      </Button>
      </Box>
    </Box>

      {/* Score + Duration */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 2,
        }}
      >
        <Box
          sx={{
            border: "1px solid #E0E0E0",
            borderRadius: 2,
            p: 2,
            bgcolor: "#F9F9F9",
            textAlign: "center",
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Interview Duration(Min.)
          </Typography>

          <Typography variant="h6" fontWeight={600}>
            {completeReport?.interviewDetails?.durationMinutes || "N/A"}
          </Typography>
        </Box>

        <Box
          sx={{
            border: "1px solid #E0E0E0",
            borderRadius: 2,
            p: 2,
            bgcolor: "#F9F9F9",
            textAlign: "center",
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Score(/10)
          </Typography>

          <Typography variant="h6" fontWeight={600}>
            {completeReport?.statistics?.averageScore || 0}
          </Typography>
        </Box>
      </Box>

      {/* Correct / Incorrect */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 2,
        }}
      >
        <Box
          sx={{
            border: "1px solid #E0E0E0",
            borderRadius: 2,
            p: 2,
            bgcolor: "#F9F9F9",
            textAlign: "center",
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Correct Answers
          </Typography>

          <Typography variant="h5" fontWeight={700}>
            {completeReport?.statistics?.correctAnswers || 0}
          </Typography>
        </Box>

        <Box
          sx={{
            border: "1px solid #E0E0E0",
            borderRadius: 2,
            p: 2,
            bgcolor: "#F9F9F9",
            textAlign: "center",
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Incorrect Answers
          </Typography>

          <Typography variant="h5" fontWeight={700}>
            {completeReport?.statistics?.incorrectAnswers || 0}
          </Typography>
        </Box>
      </Box>

      {/* Answered / Unanswered */}
      <Box
        sx={{
          border: 1,
          borderColor: "text.secondary",
          borderRadius: 2,
          p: 2,
        }}
      >
        <Typography
          variant="subtitle1"
          fontWeight={600}
          color="text.secondary"
          sx={{ mb: 1.5 }}
        >
          Question Summary
        </Typography>

        <Stack spacing={1.5}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="body2">
              Total Questions
            </Typography>

            <Typography variant="body2" fontWeight={600}>
              {completeReport?.statistics?.totalQuestions || 0}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="body2">
              Total Answered
            </Typography>

            <Typography variant="body2" fontWeight={600}>
              {completeReport?.statistics?.totalAnswered || 0}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="body2">
              Total Unanswered
            </Typography>

            <Typography variant="body2" fontWeight={600}>
              {completeReport?.statistics?.totalUnanswered || 0}
            </Typography>
          </Box>
        </Stack>
      </Box>
    </Stack>

    {/* Close Button */}
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        mt: 2,
      }}
    >
      <Button
        variant="contained"
        onClick={closeResult}
        sx={{
          mt: 1,
          bgcolor: "text.secondary",
          color: "#fff",
          px: 4,
          "&:hover": {
            bgcolor: "text.secondary",
            opacity: 0.9,
          },
        }}
      >
        Close
      </Button>
    </Box>
  </Box>
</Modal>

<Modal
  open={videoOpen}
  onClose={() => {
    setVideoOpen(false);
    setSelectedVideo("");
  }}
>
  <Box
    sx={{
      position: "fixed",
      inset: 0,
      bgcolor: "#000",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      outline: "none",
    }}
  >
    <IconButton
      onClick={() => {
        setVideoOpen(false);
        setSelectedVideo("");
      }}
      sx={{
        position: "absolute",
        top: 15,
        right: 15,
        zIndex: 10,
        color: "#fff",
        bgcolor: "rgba(0,0,0,0.5)",
        "&:hover": {
          bgcolor: "rgba(0,0,0,0.7)",
        },
      }}
    >
      <CloseIcon />
    </IconButton>

    {selectedVideo && (
   <video
  src={selectedVideo}
  controls
  autoPlay
  style={{
    width: "100%",
    height: "100%",
    objectFit: "contain",
  }}
>
  <track
    kind="captions"
    srcLang="en"
    label="English"
  />
</video>
    )}
  </Box>
</Modal>

    <Modal open={openSchedule} onClose={handleCloseSchedule}>
      <Box sx={scheduleStyle}>
        <Typography
             variant="h5"
             color="#3C6BA5"
             textAlign="center"
             fontWeight={600}
           >
             Schedule Interview
         </Typography>

       <Divider sx={{ my: 2 }} />

          <Stack spacing={3}>
            {/* Date */}
           <TextField
              label="Date"
              type="date"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={schedule.date}
             onChange={(e) =>
                  setSchedule({ ...schedule, date: e.target.value })
                 }
              />

            {/* Time */}
          <TextField
             label="Time"
               type="time"
               fullWidth
               InputLabelProps={{ shrink: true }}
               inputProps={{
                    step: 300, // 5 minutes
                   }}
                 value={schedule.time}
               onChange={(e) =>
                    setSchedule({ ...schedule, time: e.target.value })
                }
           />

               <FormControl sx={{ width: '100%', mt: 1 }}>
                                 <InputLabel id="demo-simple-select-autowidth-label">Time zone</InputLabel>
                                 <Select
                                   labelId="demo-simple-select-autowidth-label"
                                   id="demo-simple-select-autowidth"
                                   label="Time Zone"
                                   InputLabelProps={{ shrink: true }}
                                   placeholder="Time zone"
                                   // value={timez}
                                   // onChange={(e) => setTimez(e.target.value)}
                                   value={timez?.short}
                                   onChange={handleChangeTimeZ}
                                 >
                                   {/* <MenuItem value={'est'}>EST</MenuItem>
                                 <MenuItem value={'pst'}>PST</MenuItem>
                                 <MenuItem value={'mst'}>MST</MenuItem>
                                 <MenuItem value={'cst'}>CST</MenuItem>
                                 <MenuItem value={'ist'}>IST</MenuItem> */}
                                   {timeZones.map((tz) => (
                                     <MenuItem key={tz.short} value={tz.short}>
                                       {tz.short}
                                     </MenuItem>
                                   ))}
                                 </Select>
                               </FormControl>

          {/* Submit Button */}
      

          <Stack direction="column" spacing={2} alignItems="center">
         <Button
             variant="contained"
             color="custom"
             onClick={() => handleSubmitInterview(false)}
          >
            Schedule
         </Button>

         <Typography
            variant="body2"
            sx={{
               color: "text.secondary",
               fontWeight: 600,
               whiteSpace: "nowrap",
             }}
           >
          -------------- OR --------------
        </Typography>

        <Button
            variant="contained"
            color="custom"
            onClick={() => handleSubmitInterview(true)}
         >
         Request to Schedule
        </Button>
       </Stack>
      </Stack>
    </Box>
  </Modal>
        
  <Modal open={openR} onClose={closeResume} style={{ borderRadius: 10 }}>
        <Box sx={styleClients1}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
              mt: -2.5,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                textAlign: 'center',
                color: 'text.secondary',
                fontWeight: 'bold',
                flex: 1,
                mb: 1,
                mt: 1,
              }}
            >
              Resume
            </Typography>
            <a href={openRes} download>
              <Iconify icon="mdi:download" width="1.3rem" color="text.secondary" />
            </a>
          </Box>
          <Scrollbar
            sx={{
              height: '97%',
              Scrollbar: 'thin',
              border: '2px solid #3C6BA5',
              borderColor: 'text.secondary',
              borderRadius: 2,
            }}
          >
            <Stack sx={{ p: 1.5 }}>
              <Box sx={{ overflowX: 'auto', minWidth: '600px' }}>
                <iframe title="resume" src={suru + openRes + lll} width="100%" height="700px" />
              </Box>
            </Stack>
          </Scrollbar>
        </Box>
      </Modal>
       <Modal open={opens} onClose={handleCloses} style={{ borderRadius: 10 }}>
        <Box sx={styleSkillset11}>
          <Typography variant="h5" color={'#3C6BA5'} sx={{ ml: '46%' }}>
            Skills
          </Typography>

          <Scrollbar sx={{ maxHeight: 600, Scrollbar: 'thin' }}>
            <Divider sx={{ mt: 0.5, borderWidth: 1.7, borderColor: '#3C6BA5' }} />
            <Stack
              sx={{
                flexDirection: 'row',
                justifyContent: 'center',
                gap: 0.5,

                flexWrap: 'wrap',
              }}
            >
             
              {newSkill
                ?.filter((item) => item !== '' && item != null)
                .map(
                  (item, index) =>
                    item && (
                      <Box
                        key={index}
                        sx={{
                          position: 'relative',
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          mt: 2,
                        }}
                      >
                        <Typography
                          variant="h6"
                          color="text.textG"
                          textAlign="center"
                          textTransform="capitalize"
                          sx={{ paddingRight: '2px', position: 'relative', paddingTop: '-3px' }}
                        >
                          {item} {index < newSkill.length - 1 && '|'}
                        </Typography>
                      </Box>
                    )
                )}
            </Stack>
          </Scrollbar>
        </Box>
      </Modal> 
      <Modal open={open1} onClose={() => setOpen1(false)}>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
           
                width: { xs: "85%", sm: "85%", md: "670px" },
      
                bgcolor: "#fff",
                border: "3px solid #2f5f9e",
                borderRadius: "8px",
                p: 2,
                outline: "none",
              }}
            >
          
              <Typography
                align="center"
                sx={{
                  fontWeight: "bold",
                  fontSize: "20px",
                  mb: 2,
                  color: "#2f5f9e",
                }}
              >
                Screening Analysis
              </Typography>
      
             
      
              <Box sx={{ overflowX: "auto" }}>
      
      
             
              <Box
                sx={{
                  backgroundColor: "#3b6ea5",
                  display: "flex",
                  padding: "10px",
                  borderRadius: "6px",
                  color: "#fff",
                  fontWeight: "bold",
                }}
              >
                <Box sx={{ width: "25%" }}>Parameters</Box>
                <Box sx={{ width: "17%" }}> % Match</Box>
                <Box sx={{ width: "58%" }}>Summary</Box>
              </Box>
      
           
      
              <Row label="Years of Exp :" item={scoreDetails?.experienceScore} summary={scoreReasons?.experience}
       />
              <Row label="Job Title" item={scoreDetails?.jobTitleScore} summary={scoreReasons?.jobTitle} />
              <Row label="Job Tenure" item={scoreDetails?.tenureScore} summary={scoreReasons?.tenure} />

              <Row label="Skills :" item={scoreDetails?.skillsScore} summary={scoreReasons?.skills} />
              {/* <Row label="Domain :" item={scoreDetails?.domainScore} summary={scoreReasons?.domain} /> */}
              <Row label="Location :" item={scoreDetails?.locationScore} summary={scoreReasons?.location} />
              <Row label="Education :" item={scoreDetails?.educationScore} summary={scoreReasons?.education} />
                   <Row label="Domain :" item={scoreDetails?.domainScore} summary={scoreReasons?.domain} /> 
      
               </Box>
      
              <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#3b6ea5",
                    borderRadius: "8px",
                    px: 4,
                    fontWeight: "bold",
                    textTransform: "none",
                    "&:hover": { backgroundColor: "#2f5f9e" },
                  }}
                >
                {score} % Match
                </Button>
              </Box>
            </Box>
           </Modal> 
  
      </>
  );
}

const Row = ({ label, item , summary }) => {
  return (

    <Box sx={{ display: "flex", p: "12px 10px", alignItems: "center" }}>
      <Box sx={{ width: "25%", fontWeight: "bold" }}>{label}</Box>
      <Box sx={{ width: "17%", fontWeight: "bold" }}>
        {item}
      </Box>
      <Box sx={{ width: "58%" }}>{summary}</Box>
    </Box>
  );
};







































































































  











